// Path → `data-gp-name` segment: `/docs/workspace` → `docs-workspace`, `/` → `home`.
// Shared so the page segment (from the route) and an unnamed anchor's name (from
// its href) agree — a link to `/docs/teams` has to match the page it lands on.
export function pathSegmentName(path: string): string {
  return path.replace(/^\//, '').replaceAll('/', '-') || 'home';
}
